import LoadingButton from "@mui/lab/LoadingButton/LoadingButton";
import { useTheme } from "@mui/system";
import { FormButtonProps } from "./FormButtonProps";

function FormButton({ label = "Send", sx, color = "secondary", ...props }: FormButtonProps) {
  const theme = useTheme();
  return (
    <LoadingButton
      {...props}
      color={color}
      sx={[
        {
          p: "1rem 2.5rem",
          lineHeight: "1.0625rem",
          borderRadius: "1.125rem",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      variant="contained"
      {...props}
    >
      {label}
    </LoadingButton>
  );
}

export default FormButton;
